import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Landing from '@/pages/Landing';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import BuyerDashboard from '@/pages/buyer/Dashboard';
import SellerDashboard from '@/pages/seller/Dashboard';
import SellerProducts from '@/pages/seller/Products';
import AdminDashboard from '@/pages/admin/Dashboard';
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminForgotPassword from '@/pages/admin/AdminForgotPassword';
import QuoteForm from '@/pages/Quote/QuoteForm';
import QuoteDetail from '@/pages/Quote/QuoteDetail';
import CarrierComparison from '@/pages/Quote/CarrierComparison';
import EmailVerify from '@/pages/Verification/EmailVerify';
import WhatsAppVerify from '@/pages/Verification/WhatsAppVerify';
import FaceVerify from '@/pages/Verification/FaceVerify';
import BusinessVerify from '@/pages/Verification/BusinessVerify';
import PaymentSuccess from '@/pages/Payment/Success';
import PaymentCancel from '@/pages/Payment/Cancel';
import Checkout from '@/pages/Payment/Checkout';
import Marketplace from '@/pages/Marketplace/Browse';
import ProductDetail from '@/pages/Marketplace/ProductDetail';
import '@/App.css';

const PrivateRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/marketplace/product/:id" element={<ProductDetail />} />
          
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          
          <Route
            path="/buyer/dashboard"
            element={
              <PrivateRoute allowedRoles={['buyer']}>
                <BuyerDashboard />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/seller/dashboard"
            element={
              <PrivateRoute allowedRoles={['seller']}>
                <SellerDashboard />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/seller/products"
            element={
              <PrivateRoute allowedRoles={['seller']}>
                <SellerProducts />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/admin/dashboard"
            element={
              <PrivateRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          
          {/* Hidden admin login - not linked anywhere */}
          <Route path="/mx-admin-access" element={<AdminLogin />} />
          
          <Route
            path="/quote/new"
            element={
              <PrivateRoute allowedRoles={['buyer', 'seller']}>
                <QuoteForm />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/quote/compare"
            element={
              <PrivateRoute allowedRoles={['buyer', 'seller']}>
                <CarrierComparison />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/quote/:id"
            element={
              <PrivateRoute>
                <QuoteDetail />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/verify/email"
            element={
              <PrivateRoute>
                <EmailVerify />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/verify/whatsapp"
            element={
              <PrivateRoute>
                <WhatsAppVerify />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/verify/face"
            element={
              <PrivateRoute>
                <FaceVerify />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/verify/business"
            element={
              <PrivateRoute>
                <BusinessVerify />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/checkout"
            element={
              <PrivateRoute>
                <Checkout />
              </PrivateRoute>
            }
          />
          
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </>
  );
}

export default App;